<template>
  <div class="index">
    <div class="index-i">
      <div class="cards">
        <div class="card" @click="toInfo()">
          <div class="card-image">
            <img class="card-image-avatar" :src="userInfo.avatar" v-if="userInfo.avatar" />
            <img class="card-image-avatar" v-else src="../../assets/img/img_defalult_avatar.png" />
          </div>
          <div class="card-content">
            <span class="card-content__title">{{ userInfo.nickname }}</span>
            <!-- <span class="card-content__sub">积分：{{ '900' }}</span> -->
          </div>
          <div class="card-btn">
            <div class="card-btn__edit">编辑</div>
          </div>
        </div>

        <div class="card" @click="toAddress">
          <div class="card-icon">
            <img src="../../assets/img/zhanghao.png" />
          </div>
          <div class="card-content">
            <span class="card-content__title">收货地址</span>
            <span class="card-content__sub">管理我的收货地址</span>
          </div>
        </div>

        <div class="card">
          <div class="card-icon">
            <img src="../../assets/img/jihua.png" />
          </div>
          <div class="card-content">
            <span class="card-content__title">关于我们</span>
            <span class="card-content__sub">国花瓷西凤酒</span>
          </div>
        </div>

        <div class="card">
          <div class="card-icon">
            <img src="../../assets/img/mimaanquan.png" />
          </div>
          <div class="card-content">
            <span class="card-content__title">技术支持</span>
            <span class="card-content__sub">消费者服务端V1.0.0</span>
          </div>
        </div>

        <div class="card">
          <div class="card-icon">
            <img src="../../assets/img/xiaoxi.png" />
          </div>
          <div class="card-content">
            <a class="card-content__title" href="tel:4000039990">联系我们</a>
            <a class="card-content__sub" href="tel:4000039990">联系我们</a>
          </div>
        </div>

        <div class="card" @click="showBind = true">
          <div class="card-icon">
            <img src="../../assets/img/zhanghao.png" />
          </div>
          <div class="card-content">
            <span class="card-content__title">手机号绑定</span>
            <span class="card-content__sub">手机号绑定</span>
          </div>
        </div>


      </div>
    </div>

    <!-- <div class="index-btn">
      <button>退出登录</button>
    </div> -->

    <Overlay :Show="showBind">
      <div class="user-container-dialog">
        <div class="user-container-dialog__title">
          <div class="">温馨提示</div>
          <img src="../../assets/img/icon_close.png" alt="" @click="close">
        </div>
        <div class="user-container-dialog__content">为确认您的消费者身份，请填输入手机号获取验证码，手
          机号验证通过后，可以参与营销活动</div>


        <NormalInput class="user-container-dialog__inp" v-model="phone" keyname="phone" clearable placeholder="输入您的手机号"
          label="" :maxlength="11" :rules="mobileRules" @input="inputUpdate" @dropDownValueChange="fruitValueChange">
        </NormalInput>

        <!-- <div class="user-container-dialog__phone">
          <input v-model="phone" type="number" maxlength="11" placeholder="输入您的手机号" />
        </div> -->
        <div class="user-container-dialog__btn">
          <button :disabled="!phoneVerify" :style="phoneVerify ? '' : 'background: #f8dda1;'"  @click="sendCode()">继续</button>
        </div>
      </div>
    </Overlay>
    <Overlay :Show="showCode">
      <div class="user-container-dialog">
        <div class="user-container-dialog__title">
          <div class="">输入验证码</div>
          <img src="../../assets/img/icon_close.png" alt="" @click="close">
        </div>
        <div class="user-container-dialog__content">我们刚向您的手机 <span style="color: #FAC859">{{ phone.substring(0,
          3) + '****' + phone.substring(7)
            }}</span>发送了验证码</div>
        <CodeInput :size="4" @input="codeInput"></CodeInput>
        <div class="user-container-dialog__btn">
          <button @click="bindPhone()">验证</button>
        </div>
      </div>
    </Overlay>




    <!-- <div class='user-container'>
      <div class="person-wrapper">
        <img class="avatar" :src="userInfo.avatar">
        <div class="name-wrapper">
          <p>{{ userInfo.nickname }}</p>
          <!== <span>等级：小酒仙</span> ==>
        </div>
        <!== <img class="arrow" src="../../assets/icon/icons8-right_4@2x.png"> ==>
      </div>
      <div class="user-item" @click="showBindChang()" v-if="!userInfo.mobile">
        <p>绑定手机号</p>
        <div class="user-detail">
          <img src="../../assets/icon/icons8-right_4@2x.png">
        </div>
      </div>
      <div class="user-item" @click="toAddress">
        <p>收货地址管理</p>
        <div class="user-detail">
          <!== <span>3条记录</span> ==>
          <img src="../../assets/icon/icons8-right_4@2x.png">
        </div>
      </div>
      <div class="user-item" @click="toAwardLog">
        <p>我的中奖记录</p>
        <div class="user-detail">
          <img src="../../assets/icon/icons8-right_4@2x.png">
        </div>
      </div>
      <div class="user-item" @click="toReportList">
        <p>我的反馈记录</p>
        <div class="user-detail">
          <img src="../../assets/icon/icons8-right_4@2x.png">
        </div>
      </div>
      <!== <div class="user-item">
      <p>使用帮助</p>
      <div class="user-detail">
        <span>在线使用帮助</span>
        <img src="../../assets/icon/icons8-right_4@2x.png">
      </div>
    </div> ==>
      <!== <div class="user-item" @click="feedback">
      <p>问题反馈</p>
      <div class="user-detail">
        <img src="../../assets/icon/icons8-right_4@2x.png">
      </div>
    </div> ==>
      <div class="user-item">
        <p>关于我们</p>
        <div class="user-detail">
          <img src="../../assets/icon/icons8-right_4@2x.png">
        </div>
      </div>
      <div class="user-item">
        <p>当前版本</p>
        <div class="user-detail">
          <span>消费者服务端V1.0.0</span>
          <img src="../../assets/icon/icons8-right_4@2x.png">
        </div>
      </div>
    </div> -->

  </div>






</template>

<script>
// import Vue from 'vue'
// import qs from 'qs'
import { mapGetters } from 'vuex'
import Overlay from '@/components/overlay.vue'
import CodeInput from '@/components/code-input.vue'
import NormalInput from '@/components/normalInput.vue'
import { Toast } from 'vant'
import qs from 'qs'
export default {
  name: 'User',
  data() {
    return {
      showBind: false,
      showCode: false,
      phone: '',
      phoneVerify: false,
      code: '',
      mobileRules: [{ type: 'isPhoneNumber', message: '手机号格式不对' }],
      abilities: [
        {
          title: '收货地址',
          sub: '管理我的收货地址',
          image: '../../assets/img/zhanghao.png',
          url: 'address',
          isShow: true
        },
        {
          title: '密码管理',
          sub: '修改我的密码',
          image: '../../assets/img/jihua.png',
          url: 'changePassword',
          isShow: true
        },
        {
          title: '关于我们',
          sub: '国花瓷西凤酒',
          image: '../../assets/img/zhanghao.png',
          url: 'about',
          isShow: true
        },
        {
          title: '技术支持',
          sub: '软件版本V1.0',
          image: '../../assets/img/mimaanquan.png',
          url: '',
          isShow: true
        },
        {
          title: '联系我们',
          sub: '联系在线客服',
          image: '../../assets/img/xiaoxi.png',
          url: '',
          isShow: true
        }
      ]
    }
  },
  created() {
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  components: {
    Overlay,
    CodeInput,
    NormalInput
  },
  methods: {
    toInfo() {
      this.$router.push({ name: 'UserDetails' })
    },
    toAddress() {
      this.$router.push({ name: 'Address' })
    },
    toAwardLog() {
      this.$router.push({ name: 'AwardLog' })
    },
    toReportList() {
      this.$router.push({ name: 'ReportList' })
    },
    showBindChang() {
      this.showBind = true
    },
    close() {
      this.showBind = false
      this.showCode = false
    },
    fruitValueChange(e, keyname) {
      console.log(e, keyname)
      this[keyname + 'Verify'] = e
    },
    sendCode() {
      if (!this.phone || !(/^1[3456789]\d{9}$/.test(this.phone))) {
        return Toast('请输入正确的手机号')
      }
      var that = this
      var params = { mobile: this.phone, type: 1 }
      this.axios.post('/system/sms/verify_mobile/', qs.stringify(params)).then(function(res) {
        if (res.code === 0) {
          that.showBind = false
          that.showCode = true
          Toast('发送成功')
          that.timerText = '60s后重新发送'
          let total = 60
          var clock = window.setInterval(() => {
            total--
            that.timerText = total + 's后重新发送'
            if (!total) {
              total = 60
              that.timerText = ''
              clearInterval(clock)
            }
          }, 1000)
        } else {
          Toast(res.msg)
        }
      }).catch(function(error) {
        console.log(error)
        Toast('发送失败')
      })
    },
    codeInput(newCode) {
      console.log(newCode)
      this.code = newCode
    },
    bindPhone() {
      if (!this.phone) {
        return Toast('请输入手机号')
      }
      if (!this.code) {
        return Toast('请输入验证码')
      }
      var that = this
      var params = { mobile: this.phone, code: this.code }
      this.axios.post('/user/bind_mobile/', qs.stringify(params)).then(function(res) {
        console.log(res.data)
        if (!res.code) {
          Toast('绑定成功')
          that.$store.dispatch('setPhone', that.phone)
          if (that.qrcode.activity_url) {
            var path = that.qrcode.activity_url
            // var path = '/award'
            console.log(1)
            that.$router.push({ path: path, query: { serial: that.$route.query.serial }})
          } else {
            console.log(2)
            that.$router.push({ path: 'Index' })
          }
          that.showCode = false
        } else {
          that.showCode = false
          Toast(res.msg)
        }
      }).catch(function(error) {
        console.log(error)
        that.showCode = false
        Toast('绑定失败')
      })
    },
    toBind() {
      this.$router.push({ name: 'PhoneBind' })
    },
    feedback() {
      this.$router.push({ name: 'Feedback' })
    },
    inputUpdate(e) {
      console.log(e, '---')
    },
    toTest() {
      this.$router.push({ name: 'Test' })
    }
  }
}
</script>

<style lang="scss" scoped>
.index {
  background: #F6F8FA;
  height: 233px;
  background: linear-gradient(180deg, #FFE09A 0%, #F6F8FA 100%);

  &-i {

    position: relative;
    display: flex;
    flex-direction: column;

  }


  .cards {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    gap: 20px;
    margin-left: 15px;
    margin-right: 15px;

    .card {
      position: relative;
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 16px;
      background-color: #ffffff;
      border-radius: 16px;


      &-image,
      &-icon {
        width: 48px;
        height: 48px;
        border-radius: 5px;
        overflow: hidden;

        &-avatar {
          border-radius: 30px;
        }

        img {

          width: 48px;
          height: 48px;
        }
      }

      &-content {
        display: flex;
        flex-direction: column;
        gap: 5px;

        &__title {
          font-size: 17px;
          font-weight: bold;
          color: #000000;
        }

        &__sub {
          max-width: 200px;
          font-size: 14px;
          color: #A0AEC0;
        }
      }

      &-btn {
        position: absolute;
        right: 16px;
        top: 35%;

        &__edit {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 50px;
          height: 26px;
          font-size: 12px;
          font-weight: bold;
          // color: #12694E;
          // border: 1px solid #0CAF60;
          border-radius: 5px;
          color: #FFD023;
        }
      }
    }
  }

  /deep/ .login-input {
    font-size: 14px !important;
    color: #111827 !important;
    background: #F6F8FA !important;
    border-radius: 12px;
    z-index: 0;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    border: none !important;

    input {
      background-color: transparent !important;
    }
  }

  &-btn {
    position: fixed;
    bottom: 35px;
    left: 0;
    right: 0;
    padding-bottom: 20px;
    margin-left: 15px;
    margin-right: 15px;

    button {
      width: 100%;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 15px;
      padding-bottom: 15px;
      background: #FF6E6B;
      box-shadow: 0px 4px 8px 0px rgba(250, 200, 89, 0.11);
      border-radius: 12px;
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
      border-style: none;
      font-style: normal;
    }
  }
}






.user-container {
  .person-wrapper {
    height: 80px;
    padding: 0 15px;
    margin-bottom: 10px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    position: relative;

    .avatar {
      width: 60px;
      height: 60px;
      border-radius: 30px;
    }

    .name-wrapper {
      margin-left: 20px;

      p {
        color: #4a4a4a;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
      }

      span {
        color: #747474;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
      }
    }

    .arrow {
      width: 6px;
      height: 10px;
      position: absolute;
      right: 20px;
    }
  }

  .user-item:nth-child(4) {
    margin-bottom: 10px;
  }

  .user-item {
    height: 44px;
    padding: 0 20px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1px;

    p {
      color: #000000;
      font-size: 14px;
      font-weight: 400;
    }

    .user-detail {
      span {
        color: #747474;
        font-size: 14px;
        font-weight: 400;
        margin-right: 10px;
      }

      img {
        width: 6px;
        height: 10px;
      }
    }
  }

  .logo-text {
    width: 100%;
    position: fixed;
    bottom: 20px;
    text-align: center;

    p {
      color: #aaaaaa;
      font-size: 10px;
      font-weight: 400;
    }
  }


  &-dialog {
    background: #FFFFFF;
    border-radius: 16px;
    margin-left: 20px;
    margin-right: 20px;
    padding: 20px;


    &__title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #111827;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      img {
        width: 25px;
        height: 25px;
      }
    }

    &__content {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-top: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #A0AEC0;
      line-height: 17px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 10px;
    }

    &__btn {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 15px;
      padding-bottom: 15px;
      button {
        width: 100%;
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 15px;
        padding-bottom: 15px;
        background: #FAC859;
        box-shadow: 0px 4px 8px 0px rgba(250, 200, 89, 0.11);
        border-radius: 12px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        border-style: none;
        font-style: normal;
      }
    }

    &__inp {
      margin-top: 24px;
    }

    &__phone {
      margin-top: 25px;
      background: #F6F8FA;
      border-radius: 12px;

      input {
        padding: 15px;
      }

    }
  }


}
</style>



// WEBPACK FOOTER //
// src/pages/user/index.vue